import PriceDisplay from '@/components/PriceDisplay';
import {
  Typography,
  typographyVariants,
} from '@/components/primitives/Typography';
import Changeability from '@/components/purchase/card/Changeability';
import Refundability from '@/components/purchase/card/Refundability';
import { TransText } from '@/i18n/trans/text';
import type { AdmissionDTO } from '@/types/dto/agent';
import type { CheckoutOrBookingPassengerMap } from '@/types/passenger';
import { areAllAdmissionsWithValue, areRefundedLike } from '@/utils/admission';
import { cn } from '@/utils/cn';
import _uniq from 'lodash/uniq';
import { useMemo, type FC } from 'react';

interface ProductDetailsProps {
  admissions: Array<AdmissionDTO>;
  passengersMap: CheckoutOrBookingPassengerMap;
}

const ProductDetails: FC<ProductDetailsProps> = ({
  admissions,
  // passengersMap,
}) => {
  // const [isTicketViewerOpen, setIsTicketViewerOpen] = useState(false);
  //
  // const isLaptopOrBigger = useMediaQuery({
  //   minWidth: breakpoints.laptop,
  // });

  const areAllRefundable = areAllAdmissionsWithValue(
    admissions,
    'refundable',
    'YES'
  );
  const areAllExchangeable = areAllAdmissionsWithValue(
    admissions,
    'exchangeable',
    'YES'
  );
  const refundedLike = areRefundedLike(admissions);

  const passengerCount = useMemo(() => {
    const fulfilledPassengerIds = admissions
      .filter((admission) =>
        (admission.fulfillments || []).some((f) => f.status === 'FULFILLED')
      )
      .flatMap((admission) => admission.passengerIds || []);
    return _uniq(fulfilledPassengerIds).length;
  }, [admissions]);

  const admissionsAmount = useMemo(() => {
    return admissions.reduce((sum, admission) => {
      if (admission.status === 'REFUNDED') {
        return sum;
      }

      const ancillariesAmount = admission.ancillaries?.reduce(
        (total, ancillary) =>
          total + (ancillary.price?.amount || 0) * (ancillary.amountOf || 1),
        0
      );
      return sum + (admission.price?.amount || 0) + (ancillariesAmount || 0);
    }, 0);
  }, [admissions]);

  const description = admissions[0].productDescription;

  return (
    <div className="flex flex-col gap-5 laptop:gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between laptop:items-end laptop:pb-0">
          <div className="flex items-center gap-2 px-2">
            <Typography variant="body1-bold">
              {description}
              {!refundedLike && (
                <span
                  className={cn(
                    typographyVariants({ variant: 'body2' }),
                    'ml-2 align-middle text-neutral'
                  )}
                >
                  <TransText
                    i18nKey="passengersCount"
                    values={{ count: passengerCount }}
                  />
                </span>
              )}
            </Typography>
          </div>
          {!refundedLike && (
            <Typography variant="body1-bold" className="text-primary">
              <PriceDisplay amount={admissionsAmount} />
            </Typography>
          )}
        </div>
        <div className="flex gap-3 px-2">
          <Changeability condition={areAllExchangeable} />
          <Refundability condition={areAllRefundable} />
        </div>
      </div>
      {/*<Button*/}
      {/*  data-testid="product-details-view-tickets"*/}
      {/*  size={isLaptopOrBigger ? 'regular' : 'medium'}*/}
      {/*  variant="secondary"*/}
      {/*  fullWidth={!isLaptopOrBigger}*/}
      {/*  className="laptop:ml-auto laptop:w-1/2"*/}
      {/*  onClick={() => setIsTicketViewerOpen(true)}*/}
      {/*>*/}
      {/*  <Icons.ticket width={20} height={20} />*/}
      {/*  <TransText i18nKey="viewTickets" />*/}
      {/*</Button>*/}
      {/*<TicketViewerModal*/}
      {/*  admissions={admissions}*/}
      {/*  passengersMap={passengersMap}*/}
      {/*  isOpen={isTicketViewerOpen}*/}
      {/*  onOpenChange={setIsTicketViewerOpen}*/}
      {/*/>*/}
    </div>
  );
};

export default ProductDetails;
